module.exports = __webpack_public_path__ + "img/email-authentication.23d5d8e2.svg";